import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import App from './App'
// Self-hosted fonts (@fontsource) — strict CSP: no Google Fonts CDN.
import '@fontsource/manrope/400.css'
import '@fontsource/manrope/500.css'
import '@fontsource/manrope/600.css'
import '@fontsource/manrope/700.css'
import '@fontsource/manrope/800.css'
import '@fontsource/space-mono/400.css'
import '@fontsource/space-mono/700.css'
import '@fontsource/ibm-plex-sans-arabic/400.css'
import '@fontsource/ibm-plex-sans-arabic/500.css'
import '@fontsource/ibm-plex-sans-arabic/600.css'
import '@fontsource/ibm-plex-sans-arabic/700.css'
import './index.css'
// V1.9.1 design tokens (docs/current/design_handoff_my_trumin_v1_9_1) — loaded
// after index.css so the [dir='rtl'] font swap wins over the body default.
import './theme/tokens.css'

// SENTRY (Duncan express order BOARDROOM-2026-09-10-204131 — fleet rollout,
// 'maximum troubleshooting visibility before Sunday'): errors-only telemetry.
// 100% error sampling, NO perf tracing, NO PII beyond SDK defaults (no
// emails/names in tags — sendDefaultPii false). environment: 'stage' from the
// --mode stage build; the plain prod build's MODE 'production' maps to 'prod'
// so the prod deploy rides unchanged. release: the git sha the deploy script
// exports as VITE_GIT_SHA (absent locally ⇒ undefined, events still ingest).
Sentry.init({
  dsn: 'https://faf2cac423da12d29cda88afa41b2c0e@o4511897525157888.ingest.de.sentry.io/4512063995576400',
  environment: import.meta.env.MODE === 'production' ? 'prod' : import.meta.env.MODE,
  release: import.meta.env.VITE_GIT_SHA || undefined,
  sampleRate: 1.0,
  tracesSampleRate: 0,
  sendDefaultPii: false,
})
// Wiring smoke hook (the rollout order's test-error verify lane): a
// `?sentry_test=1` visit emits ONE tagged message so a dashboard read proves
// ingest without anyone breaking the app on purpose. No user data rides it.
if (new URLSearchParams(window.location.search).has('sentry_test')) {
  Sentry.captureMessage('my.trumin sentry wiring test', 'info')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Sentry ErrorBoundary at the root (per the rollout order): a crashed
        render reports to Sentry and shows an honest plain-text fallback
        instead of a silent white screen. */}
    <Sentry.ErrorBoundary fallback={<p style={{ padding: 24, fontFamily: 'sans-serif' }}>Something went wrong. Please refresh the page.</p>}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
